import { render, staticRenderFns } from "./OcrCreate.vue?vue&type=template&id=dbe35496&scoped=true&"
import script from "./OcrCreate.vue?vue&type=script&lang=js&"
export * from "./OcrCreate.vue?vue&type=script&lang=js&"
import style0 from "./OcrCreate.vue?vue&type=style&index=0&id=dbe35496&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe35496",
  null
  
)

export default component.exports